'use client';

import FeatureSectionDynamicList, {
  FeatureSectionDynamicListProps,
} from 'components/padi-ui/feature-section/dynamic-list';
import { TasticProps } from 'frontastic/tastics/types';

const FeatureSectionDynamicListTastic = ({ data }: TasticProps<FeatureSectionDynamicListProps>) => {
  return <FeatureSectionDynamicList {...data} />;
};

export default FeatureSectionDynamicListTastic;
